import * as React from 'react';
import Table from './PriceTable';
import { PaymentBridge } from './PaymentBridge';

const PricingTable = (props) => {
  return <Table {...props} />;
};

export default PricingTable;
